import { Col, Row } from "react-bootstrap";
import CompoPageFilter from "./Common/CompoPageFilter";
import { useState } from "react";
import { RangeSelection } from "../assets/interfaces/FX_POS_Interfaces";
import { useNavigate } from "react-router-dom";

interface PropData {
    title: string,
    backArrow?: boolean;
    navigateURL?: string;
    isHideFilters?: boolean;
    isHideOutlet?: boolean;
    isHideDateRange?: boolean;
    defaultRangeDays?: number
    defaultSelectedRange?: RangeSelection
    changeEvent?: (type: string, value: string | null) => void
}

const PageTitle = ({ title, backArrow, changeEvent, isHideFilters, isHideOutlet, isHideDateRange,
    defaultRangeDays = 30, navigateURL, defaultSelectedRange }: PropData) => {
    let navigate = useNavigate();
    const goBack = () => {
        if (navigateURL) {
            navigate(navigateURL);
        } else {
            window.history.back();
        }
    };
    const [selectedRange, setSelectedRange] = useState<RangeSelection>(defaultSelectedRange || { startDate: new Date(new Date().setDate(new Date().getDate() - defaultRangeDays)), endDate: new Date() });

    const handleCommonFilterChange = (params: any | null, type: string) => {
        if (type === "OUTLET") {
            localStorage.setItem("outlet_id", params ? params : "");
            changeEvent?.(type, params)
        } else if (type === "RANGE") {
            changeEvent?.(type, params)
        }
    };
    return (
        <>

            <Row className="align-items-center justify-content-between mb-1 mt-3">
                <Col lg={4} className="mb-lg-3 mb-3 text-wrap">
                    <div className="d-flex gap-3 align-items-center flex-wrap">
                        {
                            backArrow == true
                                ?
                                (
                                    <a className="text-dark mb-1 cursor-pointer" onClick={goBack}>
                                        <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.3577 6.25L6.6807 9.573C6.8192 9.7115 6.89004 9.88559 6.8932 10.0953C6.89637 10.3048 6.82554 10.482 6.6807 10.627C6.53587 10.7718 6.3602 10.8443 6.1537 10.8443C5.94737 10.8443 5.77179 10.7718 5.62695 10.627L1.1327 6.13275C1.03904 6.03909 0.973036 5.94034 0.934703 5.8365C0.896203 5.73267 0.876953 5.6205 0.876953 5.5C0.876953 5.3795 0.896203 5.26734 0.934703 5.1635C0.973036 5.05967 1.03904 4.96092 1.1327 4.86725L5.62695 0.373002C5.76545 0.234669 5.93945 0.163835 6.14895 0.160502C6.35862 0.157335 6.53587 0.228169 6.6807 0.373002C6.82554 0.518002 6.89795 0.693669 6.89795 0.900002C6.89795 1.10634 6.82554 1.282 6.6807 1.427L3.3577 4.75H16.75C16.9628 4.75 17.141 4.82184 17.2845 4.9655C17.4281 5.109 17.5 5.28717 17.5 5.5C17.5 5.71284 17.4281 5.891 17.2845 6.0345C17.141 6.17817 16.9628 6.25 16.75 6.25H3.3577Z" fill="#111111" />
                                        </svg>

                                    </a>
                                )
                                :
                                null
                        }
                        <h1 className="page-title font-24 font-regular mb-0 text-break">{title}</h1></div>
                </Col>
                <Col lg={8}>
                    {!isHideFilters &&
                        <CompoPageFilter
                            handleOutletSelection={(params: string | null, type: string) =>
                                handleCommonFilterChange(params, type)
                            }
                            isHideDateRange={isHideDateRange}
                            isHideOutlet={isHideOutlet}
                            rangeSelection={selectedRange}
                            setRangeSelection={(value) => { setSelectedRange(value) }}
                        />
                    }
                </Col>
            </Row>

        </>
    )
}
export default PageTitle;